export default __webpack_public_path__ + "static/media/deshacer.d8198ee4.svg";